import { gql } from '@apollo/client';
import { Gender, IEmployeeBaseData, IName, IUser } from '@dokucoach/common-types';
import {
  queryEmployeeNameAndId,
  queryEmployeeSystemAccessData,
  queryGeneralData,
  queryListData,
} from './query/employees';

export type UserWithRole = Partial<{
  role: {
    name: string;
    rights: string[];
  };
}> &
  Partial<IUser>;

export interface EmployeeListData {
  id: string;
  deletedAt?: Date | null;
  name: {
    firstFull: string;
    last: string;
    gender: Gender;
    title: string;
  };
  identifier?: string;
  employeeBaseData: Partial<IEmployeeBaseData>;
  user: UserWithRole;
  profilePictureUrl?: string | null;
}

export type EmployeeSystemAccessPropType = Partial<{
  deletedAt: Date | null;
  role: Partial<{
    id: string;
    name: string;
  }>;
  initials: string;
  username: string;
  passwordGenerated: boolean;
}>;

export const GET_EMPLOYEES = gql`
  query getEmployees($isDeleted: Boolean!) {
    getEmployees(isDeleted: $isDeleted) {
      ${queryListData}
    }
  }
`;

export const GET_EMPLOYEES_NAME_AND_ID = gql`
  query getEmployeesNameAndId($isDeleted: Boolean!) {
    getEmployees(isDeleted: $isDeleted) {
      ${queryEmployeeNameAndId}
    }
  }
`;

export const GET_EMPLOYEE_BY_ID = gql`
  query getEmployee($id: ID!) {
    getEmployee(id: $id) {
      ${queryGeneralData}
    }
  }
`;

export const GET_EMPLOYEE_SYSTEM_ACCESS = gql`
  query getEmployee($id: ID!) {
    getEmployee(id: $id) {
      ${queryEmployeeSystemAccessData}
    }
  }
`;

export type Employee = Partial<{
  id: string;
  deletedAt?: Date;
  nursingHomeId: string;
  name: IName;
  identifier: string;
  employeeBaseData: IEmployeeBaseData;
  user: IUser;
}>;

export const VALIDATE_IDENTIFIER = gql`
  query validateIdentifier($identifier: String!) {
    validateEmployeeIdentifier(identifier: $identifier)
  }
`;
